var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "v-room-detail",
      class: {
        "is-crazy-mode": _vm.roomDetail.room.isCrazyMode == 1,
        "is-team-mode": _vm.roomDetail.room.isTeamMode == 1,
      },
    },
    [
      _c("div", { staticClass: "bg" }),
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "title-con", staticStyle: { "margin-top": "10px" } },
          [
            _c("div", { staticClass: "return-btn-con flex flex-ver" }, [
              _vm.IsUserInRoom &&
              _vm.battleChallengeDetail.isChallengeEnable &&
              _vm.battleChallengeDetail.winningRoomId ==
                _vm.roomDetail.room.id &&
              _vm.battleChallengeDetail.isCurrentlyInChallenge &&
              _vm.battleChallengeDetail.winningSteakCount > 0 &&
              _vm.curRoomState == 3 &&
              _vm.roomDetail.room.winner_id &&
              _vm.roomDetail.room.winner_id == _vm.curUserRealId
                ? _c("div", { staticClass: "flex flex-ver" }, [
                    _c("div", { staticClass: "flex flex-ver" }, [
                      _c("div", {
                        staticClass: "return-btn el-icon-arrow-left",
                        attrs: {
                          width: _vm.backIconWidthHeight,
                          height: _vm.backIconWidthHeight,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$router.go(-1)
                          },
                        },
                      }),
                      _c("div", { staticClass: "return-btn-text" }, [
                        _vm._v("继续连胜挑战"),
                      ]),
                    ]),
                    _c("img", {
                      staticClass: "battleChallengeDetail__icon",
                      attrs: {
                        src: require("../../../assets/images/help_fill.png"),
                        alt: "",
                      },
                      on: {
                        click: function () {
                          _vm.battle_detail_challenge_des_show = true
                          _vm.battle_challenge_des_btn_show = false
                        },
                      },
                    }),
                  ])
                : _c("div", { staticClass: "flex flex-ver" }, [
                    _c("div", {
                      staticClass: "return-btn el-icon-arrow-left",
                      attrs: {
                        width: _vm.backIconWidthHeight,
                        height: _vm.backIconWidthHeight,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.$router.go(-1)
                        },
                      },
                    }),
                    _c("div", { staticClass: "return-btn-text" }, [
                      _vm._v("战斗"),
                    ]),
                  ]),
              _vm.IsUserInRoom &&
              _vm.battleChallengeDetail.isChallengeEnable &&
              !_vm.battleChallengeDetail.isCurrentlyInChallenge &&
              _vm.battleChallengeDetail.winningSteakCount > 0
                ? _c("div", { staticClass: "user-tabs__challenge" }, [
                    _c("div", { staticClass: "user-tabs__challenge__top" }, [
                      _c("p", [_vm._v("连胜挑战")]),
                      _c("img", {
                        attrs: {
                          src: require("../../../assets/images/help_fill.png"),
                        },
                        on: {
                          click: function () {
                            _vm.battle_detail_challenge_des_show = true
                            _vm.battle_challenge_des_btn_show = false
                          },
                        },
                      }),
                    ]),
                    _c("div", { staticClass: "user-tabs__challenge__bottom" }, [
                      _c(
                        "button",
                        {
                          staticClass: "join-challenge-btn",
                          on: { click: _vm.onJoinChallengeHandle },
                        },
                        [_vm._v("加入")]
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm.IsUserInRoom && _vm.battleChallengeDetail.isChallengeEnable
              ? [
                  _vm.battleChallengeDetail.isCurrentlyInChallenge &&
                  !_vm.isChallengeFailed &&
                  (_vm.curRoomState < 3 ||
                    (_vm.curRoomState == 3 &&
                      _vm.roomDetail.room.winner_id &&
                      _vm.roomDetail.room.winner_id == _vm.curUserRealId))
                    ? _c(
                        "div",
                        { staticClass: "challenge__items flex flex-center-1" },
                        [
                          _c("p", [
                            _vm._v(
                              "连胜" +
                                _vm._s(
                                  _vm.battleChallengeDetail.winningSteakCount
                                ) +
                                "关"
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  !_vm.battleChallengeDetail.isCurrentlyInChallenge &&
                  _vm.isChallengeFailed &&
                  _vm.isChallengeFailedRoomId == _vm.roomDetail.room.id &&
                  _vm.curRoomState == 3 &&
                  _vm.roomDetail.room.winner_id &&
                  _vm.roomDetail.room.winner_id != _vm.curUserRealId
                    ? _c(
                        "div",
                        { staticClass: "challenge__items flex flex-center-1" },
                        [
                          _vm.roomDetail.room.winner_id
                            ? _c("p", [_vm._v("挑战失败")])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
            _c("div", { staticClass: "link" }, [
              _c(
                "div",
                {
                  staticClass: "link-item flex flex-ver",
                  on: { click: _vm.copyRoomUrl },
                },
                [
                  _c("i", { staticClass: "ivu-icon ivu-icon-ios-link" }),
                  _c("span", { staticClass: "text" }, [
                    _vm._v(_vm._s(_vm.curPageUrl)),
                  ]),
                ]
              ),
            ]),
          ],
          2
        ),
        _vm.IsUserInRoom && _vm.battleChallengeDetail.isChallengeEnable
          ? _c("div", { staticClass: "phone__challagen_result_item" }, [
              _vm.battleChallengeDetail.isCurrentlyInChallenge &&
              !_vm.isChallengeFailed &&
              (_vm.curRoomState < 3 ||
                (_vm.curRoomState == 3 &&
                  _vm.roomDetail.room.winner_id &&
                  _vm.roomDetail.room.winner_id == _vm.curUserRealId))
                ? _c(
                    "div",
                    { staticClass: "challenge__items flex flex-center-1" },
                    [
                      _c("p", [
                        _vm._v(
                          "连胜" +
                            _vm._s(
                              _vm.battleChallengeDetail.winningSteakCount
                            ) +
                            "关"
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              !_vm.battleChallengeDetail.isCurrentlyInChallenge &&
              _vm.isChallengeFailed &&
              _vm.isChallengeFailedRoomId == _vm.roomDetail.room.id &&
              _vm.curRoomState == 3 &&
              _vm.roomDetail.room.winner_id &&
              _vm.roomDetail.room.winner_id != _vm.curUserRealId
                ? _c(
                    "div",
                    { staticClass: "challenge__items flex flex-center-1" },
                    [
                      _vm.roomDetail.room.winner_id
                        ? _c("p", [_vm._v("挑战失败")])
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ])
          : _vm._e(),
        _c("div", { staticClass: "round-detail-box" }, [
          _c("div", { staticClass: "round-case-detail-box" }, [
            _c("div", { staticClass: "round-item-scroll" }, [
              _c(
                "div",
                {
                  ref: "round_list",
                  staticClass: "round-item-list",
                  staticStyle: { "margin-left": "0px" },
                },
                _vm._l(_vm.roomDetail.room.cases, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "battle-case-item",
                      class: {
                        active:
                          index === _vm.curRoundIndex && _vm.curRoomState == 1,
                      },
                      style:
                        "background-image: url('" +
                        _vm.$imgfilter(item.casePic) +
                        "');",
                      on: {
                        click: function ($event) {
                          return _vm.openCaseDetailModal(item)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "case-title" }, [
                        _vm._v(_vm._s(item.caseName)),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _vm.curRoomState == 3
            ? _c("div", { staticClass: "btn" }, [
                _c("div", {
                  staticClass: "btn-replay",
                  on: { click: _vm.replay },
                }),
              ])
            : _vm._e(),
          _c("div", { staticClass: "rounds" }, [
            _c("span", [_vm._v("回合")]),
            _c("span", { staticClass: "text" }, [
              _c("span", [_vm._v(_vm._s(_vm.curRoundText))]),
              _vm._v("/ " + _vm._s(_vm.roomDetail.room.cases.length) + " "),
            ]),
          ]),
          _c("div", { staticClass: "cost" }, [
            _c("span", [_vm._v("总价格")]),
            _c("span", { staticClass: "text" }, [
              _vm._v(" " + _vm._s(_vm.roomDetail.room.roomPrice) + " "),
              _vm.isHappyCoin ? _c("span", [_vm._v("欢乐豆")]) : _vm._e(),
            ]),
          ]),
        ]),
        !_vm.roomDetail.room.id
          ? _c("div", { staticClass: "skeleton-battle-wrapper" }, [
              _c(
                "div",
                {
                  staticClass: "skeleton-players-grid",
                  class: "grid-" + (_vm.roomDetail.room.seatCount || 4),
                },
                _vm._l(_vm.roomDetail.room.seatCount || 4, function (n) {
                  return _c(
                    "div",
                    { key: n, staticClass: "skeleton-player-card" },
                    [
                      _vm._m(0, true),
                      _vm._m(1, true),
                      _c("div", { staticClass: "skeleton-profit-bar" }),
                    ]
                  )
                }),
                0
              ),
            ])
          : _c(
              "div",
              { ref: "seatContainerBox", staticClass: "seat-container-box" },
              _vm._l(_vm.seatList, function (player, SeatIndex) {
                return _c("div", { key: SeatIndex, staticClass: "seat-item" }, [
                  !player
                    ? _c("div", [
                        _c("div", { staticClass: "item-top wait-not-ready" }, [
                          _c(
                            "div",
                            {
                              staticClass: "top-center",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function ($event) {
                                  return _vm.openJoinRoomModal(SeatIndex)
                                },
                              },
                            },
                            [
                              _vm._m(2, true),
                              _c("p", { staticClass: "text active" }, [
                                _vm._v("Wait"),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "item-bottom" }, [
                          _vm.roomDetail.room.memberid == _vm.curUserRealId
                            ? _c(
                                "div",
                                {
                                  staticClass: "inv-bot-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openAiMatchModal(SeatIndex)
                                    },
                                  },
                                },
                                [_vm._v(" 匹配AI ")]
                              )
                            : _vm._e(),
                          _vm.roomDetail.room.memberid == _vm.curUserRealId
                            ? _c(
                                "div",
                                {
                                  staticClass: "inv-bot-btn",
                                  on: { click: _vm.CancelBattle },
                                },
                                [_vm._v(" 取消这局 ")]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "inv-bot-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.openJoinRoomModal(SeatIndex)
                                    },
                                  },
                                },
                                [_vm._v(" 加入 ")]
                              ),
                        ]),
                      ])
                    : _c(
                        "div",
                        [
                          _c(
                            "div",
                            {
                              staticClass: "item-top",
                              class: { "wait-ready": _vm.curRoomState == 0 },
                            },
                            [
                              _vm.showProgress && _vm.curRoomState == 1
                                ? _c("div", {
                                    staticClass: "progess-line",
                                    class:
                                      _vm.getCurUserRoundIsWin(
                                        player.memberid,
                                        _vm.curRoundIndex + 1
                                      ) == "win"
                                        ? "win"
                                        : _vm.getCurUserRoundIsWin(
                                            player.memberid,
                                            _vm.curRoundIndex + 1
                                          ) == "tie"
                                        ? "tie"
                                        : "",
                                    style: {
                                      "--progress":
                                        (player.items[_vm.curRoundIndex].price /
                                          _vm.curItemMaxPrice) *
                                          100 +
                                        "%",
                                    },
                                  })
                                : _vm._e(),
                              _vm.curRoomState == 0
                                ? _c("div", { staticClass: "top-center" }, [
                                    _vm._m(3, true),
                                    _c("p", { staticClass: "text active" }, [
                                      _vm._v("Ready"),
                                    ]),
                                  ])
                                : _vm._e(),
                              _c("c-battle-open", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.curRoomState == 1,
                                    expression: "curRoomState == 1",
                                  },
                                ],
                                ref: "rollbox_" + player.id,
                                refInFor: true,
                              }),
                              _vm.curRoomState >= 2
                                ? _c(
                                    "div",
                                    {
                                      class:
                                        (_vm.curRoomState == 3 &&
                                          player.isWinner &&
                                          _vm.currentIsWinner.length !=
                                            _vm.roomDetail.players.length) ||
                                        (_vm.curRoomState == 2 &&
                                          _vm.getCurUserRoundIsWin(
                                            player.memberid,
                                            _vm.curAcountingIndex
                                          ) == "win")
                                          ? "win-item"
                                          : (_vm.curRoomState == 3 &&
                                              player.isWinner &&
                                              _vm.currentIsWinner.length ==
                                                _vm.roomDetail.players
                                                  .length) ||
                                            (_vm.curRoomState == 2 &&
                                              _vm.getCurUserRoundIsWin(
                                                player.memberid,
                                                _vm.curAcountingIndex
                                              ) == "tie")
                                          ? "tie-item"
                                          : "lost-item",
                                    },
                                    [
                                      (player.isWinner &&
                                        _vm.curRoomState == 3 &&
                                        _vm.currentIsWinner.length !=
                                          _vm.roomDetail.players.length) ||
                                      (_vm.getCurUserRoundIsWin(
                                        player.memberid,
                                        _vm.curAcountingIndex
                                      ) == "win" &&
                                        _vm.curRoomState == 2)
                                        ? _c(
                                            "div",
                                            { staticClass: "win-message" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "win-message__title",
                                                  class: {
                                                    show: _vm.curRoomState == 3,
                                                  },
                                                },
                                                [_vm._v("胜")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "calculating-hexagon win-sum win",
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass: "depth-1",
                                                  }),
                                                  _c(
                                                    "div",
                                                    { staticClass: "depth-2" },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "win-message__price",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "bold transition",
                                                              },
                                                              [
                                                                _c("c-number", {
                                                                  attrs: {
                                                                    duration: 500,
                                                                    from: 0,
                                                                    to: _vm.getCurCountUserProfit(
                                                                      player.memberid
                                                                    ),
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "win-message__box",
                                                  class: {
                                                    show: _vm.curRoomState == 3,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "win-message__title2",
                                                    },
                                                    [_vm._v("总价值")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "win-message__total",
                                                      attrs: {
                                                        id: "battle-total",
                                                      },
                                                    },
                                                    [
                                                      _c("c-number", {
                                                        attrs: {
                                                          from: 0,
                                                          to: _vm.getCurUserProfit(
                                                            player.memberid
                                                          ),
                                                        },
                                                      }),
                                                      _vm.isHappyCoin
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "14px",
                                                                "margin-left":
                                                                  "2px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "欢乐豆 - 已自动售出"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : (player.isWinner &&
                                            _vm.curRoomState == 3 &&
                                            _vm.currentIsWinner.length ==
                                              _vm.roomDetail.players.length) ||
                                          (_vm.getCurUserRoundIsWin(
                                            player.memberid,
                                            _vm.curAcountingIndex
                                          ) == "tie" &&
                                            _vm.curRoomState == 2)
                                        ? _c(
                                            "div",
                                            { staticClass: "tie-message" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "tie-message__title",
                                                  class: {
                                                    show: _vm.curRoomState == 3,
                                                  },
                                                },
                                                [_vm._v("平")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "calculating-hexagon win-sum tie",
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass: "depth-1",
                                                  }),
                                                  _c(
                                                    "div",
                                                    { staticClass: "depth-2" },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "tie-message__price",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "bold transition",
                                                              },
                                                              [
                                                                _c("c-number", {
                                                                  attrs: {
                                                                    duration: 500,
                                                                    from: 0,
                                                                    to: _vm.getCurCountUserProfit(
                                                                      player.memberid
                                                                    ),
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "tie-message__box",
                                                  class: {
                                                    show: _vm.curRoomState == 3,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "tie-message__title2",
                                                    },
                                                    [_vm._v("总价值")]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "tie-message__total",
                                                      attrs: {
                                                        id: "battle-total",
                                                      },
                                                    },
                                                    [
                                                      _c("c-number", {
                                                        attrs: {
                                                          from: 0,
                                                          to: _vm.getCurUserProfit(
                                                            player.memberid
                                                          ),
                                                        },
                                                      }),
                                                      _vm.isHappyCoin
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "14px",
                                                                "margin-left":
                                                                  "2px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "欢乐豆 - 已自动售出"
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "lose-message" },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "lose-message__title",
                                                  class: {
                                                    show: _vm.curRoomState == 3,
                                                  },
                                                },
                                                [_vm._v("败:(")]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "calculating-hexagon win-sum lose",
                                                },
                                                [
                                                  _c("div", {
                                                    staticClass: "depth-1",
                                                  }),
                                                  _c(
                                                    "div",
                                                    { staticClass: "depth-2" },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "lose-message__price",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "bold transition",
                                                              },
                                                              [
                                                                _c("c-number", {
                                                                  attrs: {
                                                                    duration: 500,
                                                                    from: 0,
                                                                    to: _vm.getCurCountUserProfit(
                                                                      player.memberid
                                                                    ),
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "item-bottom" }, [
                            _c("div", { staticClass: "user-info" }, [
                              _c(
                                "div",
                                {
                                  ref: "battleUserinfo",
                                  refInFor: true,
                                  staticClass: "avatar-box",
                                  staticStyle: { "z-index": "0" },
                                },
                                [
                                  _c(
                                    "c-quick-chat-poptip",
                                    {
                                      ref: "poptip",
                                      refInFor: true,
                                      attrs: {
                                        "word-wrap": true,
                                        placement: "top",
                                        trigger: "click",
                                        content:
                                          _vm.user_chat_list[SeatIndex].text,
                                      },
                                      model: {
                                        value:
                                          _vm.user_chat_list[SeatIndex].show,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.user_chat_list[SeatIndex],
                                            "show",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "user_chat_list[SeatIndex].show",
                                      },
                                    },
                                    [
                                      _c("c-avatar", {
                                        attrs: {
                                          src: player.avatar,
                                          width: "40px",
                                          vip: player.vipLevel,
                                          is_streamer: player.isStreamer,
                                          is_robot: player.isRobot,
                                          curr_metal_url: player.currMetalUrl,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "info-box" }, [
                                _c(
                                  "p",
                                  { staticClass: "user-name text-hidden" },
                                  [_vm._v(_vm._s(player.name))]
                                ),
                                _vm.curRoomState == 1
                                  ? _c(
                                      "p",
                                      { staticClass: "win-rate text-hidden" },
                                      [
                                        _vm._v("当前: "),
                                        _c("c-number", {
                                          attrs: {
                                            duration: 500,
                                            from: 0,
                                            to: _vm.getCurUserProfit(
                                              player.memberid
                                            ),
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                            _c(
                              "div",
                              { staticClass: "top-title" },
                              [
                                player.memberid == _vm.curUserRealId
                                  ? _c(
                                      "Dropdown",
                                      {
                                        attrs: {
                                          transfer: "",
                                          trigger: "click",
                                          placement: "top",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "list",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "DropdownMenu",
                                                    _vm._l(
                                                      _vm.quick_msg_list,
                                                      function (
                                                        msg,
                                                        msg_index
                                                      ) {
                                                        return _c(
                                                          "DropdownItem",
                                                          {
                                                            key:
                                                              msg.id ||
                                                              msg_index,
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.cgChat(
                                                                        SeatIndex,
                                                                        msg_index
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    msg.text
                                                                  ) + " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "emoji-btn" },
                                          [
                                            _c("c-svg", {
                                              attrs: {
                                                src: "message.svg",
                                                width: "30",
                                                height: "30",
                                                fill: "#F5B844",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm.curRoomState > 0
                            ? _c(
                                "transition-group",
                                {
                                  staticClass: "gun-list",
                                  attrs: { tag: "div", name: "seatReward" },
                                },
                                [
                                  _vm._l(
                                    _vm.getCurUserPrize(player.memberid),
                                    function (award, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: "award-open-" + index,
                                          staticClass: "gun-item",
                                          class: [
                                            {
                                              shake:
                                                _vm.curAcountingIndex - 1 ==
                                                  index &&
                                                _vm.curRoomState == 2,
                                            },
                                            {
                                              small:
                                                _vm.roomDetail.players.length <
                                                3,
                                            },
                                          ],
                                        },
                                        [
                                          _c("c-award", {
                                            staticClass: "award",
                                            attrs: {
                                              rarity: award.rarity,
                                              picture: award.itemPic,
                                              name: award.name,
                                              price: award.price,
                                              rate: award.viewRate,
                                              width: "100%",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _vm._l(5, function (a, b) {
                                    return _c("div", {
                                      key: "placeholder" + b,
                                      staticClass: "gun-item placeholder",
                                      class: {
                                        small:
                                          _vm.roomDetail.players.length < 3,
                                      },
                                    })
                                  }),
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                ])
              }),
              0
            ),
      ]),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            "footer-hide": "",
            width: "'400rem'",
            closable: false,
          },
          model: {
            value: _vm.join_room_modal.flag,
            callback: function ($$v) {
              _vm.$set(_vm.join_room_modal, "flag", $$v)
            },
            expression: "join_room_modal.flag",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "加入对战", has_close_button: "" },
              on: {
                close_button_click: function () {
                  return (_vm.join_room_modal.flag = false)
                },
              },
            },
            [
              _c("div", { staticClass: "app-form" }, [
                _c(
                  "p",
                  { staticClass: "join_room_modal_desc" },
                  [
                    _vm._v(" 加入费用: "),
                    _c("c-svg", {
                      staticClass: "icon",
                      attrs: { src: "bill.svg", width: "16" },
                    }),
                    _vm._v(_vm._s(_vm.join_room_modal.price) + " "),
                    _vm.isHappyCoin ? _c("span", [_vm._v("欢乐豆")]) : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm.join_room_modal.hasPassword
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.join_room_modal.password,
                        expression: "join_room_modal.password",
                      },
                    ],
                    staticClass: "form-input",
                    attrs: { placeholder: "请输入房间密码" },
                    domProps: { value: _vm.join_room_modal.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.join_room_modal,
                          "password",
                          $event.target.value
                        )
                      },
                    },
                  })
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "submit-button",
                  staticStyle: { width: "100%" },
                  on: { click: _vm.submit_join_room },
                },
                [_vm._v("确认加入")]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal ai-match-dialog",
            "footer-hide": "",
            width: "'600rem'",
            closable: false,
          },
          model: {
            value: _vm.showQuickMatchDialog,
            callback: function ($$v) {
              _vm.showQuickMatchDialog = $$v
            },
            expression: "showQuickMatchDialog",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "匹配AI", has_close_button: "" },
              on: {
                close_button_click: function () {
                  return (_vm.showQuickMatchDialog = false)
                },
              },
            },
            [
              _c("div", { staticClass: "ai-match-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "auto-match-section",
                    on: { click: _vm.handleAutoMatch },
                  },
                  [
                    _c("div", { staticClass: "auto-match-btn-content" }, [
                      _c("i", { staticClass: "el-icon-cpu auto-icon" }),
                      _c("div", { staticClass: "text-group" }, [
                        _c("span", { staticClass: "main-title" }, [
                          _vm._v("系统智能自动匹配"),
                        ]),
                        _c("span", { staticClass: "sub-title" }, [
                          _vm._v("随机挑选一位可用AI加入战斗"),
                        ]),
                      ]),
                    ]),
                    _c("i", { staticClass: "el-icon-arrow-right arrow" }),
                  ]
                ),
                _c("div", { staticClass: "divider" }, [
                  _c("span", [_vm._v("或指定指定AI坐席")]),
                ]),
                _c(
                  "div",
                  { staticClass: "search-box-wrapper" },
                  [
                    _c("el-input", {
                      staticClass: "ai-search-input",
                      attrs: {
                        placeholder: "输入 AI 昵称进行模糊搜索...",
                        "prefix-icon": "el-icon-search",
                        clearable: "",
                        size: "small",
                      },
                      model: {
                        value: _vm.aiSearchQuery,
                        callback: function ($$v) {
                          _vm.aiSearchQuery = $$v
                        },
                        expression: "aiSearchQuery",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "ai-list-wrapper" },
                  _vm._l(_vm.filteredAiList, function (ai) {
                    return _c(
                      "div",
                      {
                        key: ai.botId,
                        staticClass: "ai-item",
                        class: { active: _vm.selectedAiId === ai.botId },
                        on: {
                          click: function ($event) {
                            _vm.selectedAiId = ai.botId
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "ai-info" }, [
                          _c(
                            "div",
                            { staticClass: "avatar-wrapper" },
                            [
                              _c("c-avatar", {
                                attrs: {
                                  src: ai.avatar,
                                  width: "40px",
                                  vip: ai.vipLevel,
                                  is_streamer: false,
                                  is_robot: true,
                                },
                              }),
                              _c("span", {
                                staticClass: "status-dot",
                                class: ai.status,
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "ai-meta" }, [
                            _c("span", { staticClass: "ai-name" }, [
                              _vm._v(_vm._s(ai.name)),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "select-checkbox" }, [
                          _vm.selectedAiId === ai.id
                            ? _c("i", { staticClass: "el-icon-check" })
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
              ]),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "cancel-btn",
                      on: {
                        click: function ($event) {
                          _vm.showQuickMatchDialog = false
                        },
                      },
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "confirm-match-btn",
                      attrs: { disabled: !_vm.selectedAiId },
                      on: { click: _vm.handleMatchSpecifiedAi },
                    },
                    [_vm._v(" 确 定 ")]
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "500rem",
            closable: false,
          },
          model: {
            value: _vm.battle_detail_challenge_des_show,
            callback: function ($$v) {
              _vm.battle_detail_challenge_des_show = $$v
            },
            expression: "battle_detail_challenge_des_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "连胜挑战活动说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.battle_detail_challenge_des_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content challenge_des_item" }, [
                _c(
                  "p",
                  [
                    _vm._v(" 获胜任一关盒战即可参加连胜挑战活动:"),
                    _c("br"),
                    _vm._l(_vm.cdkGiftRateList, function (item) {
                      return [
                        _vm._v(
                          " 连胜" +
                            _vm._s(item.num) +
                            "关，奖励为第1关的门票总价格 X " +
                            _vm._s(item.rate) +
                            "倍数 CDK。"
                        ),
                        _c("br"),
                      ]
                    }),
                    _vm._v(" (第一位连胜12关的玩家，送 "),
                    _c("strong", [_vm._v("AWP王子-崭新出厂")]),
                    _vm._v("一把) "),
                    _c("br"),
                    _c("br"),
                    _vm._v(" 注意事项: "),
                    _c("br"),
                    _vm._v(
                      " 1. 下一关门票总价格必须高于前一关，胜利才符合连胜资格。"
                    ),
                    _c("br"),
                    _vm._v(" 2. 对战失败时挑战结束，无法领取连胜奖励。"),
                    _c("br"),
                    _vm._v(" 3. 领取当前连胜奖励后，挑战结束。"),
                    _c("br"),
                    _vm._v(" 4. 未领取连胜奖励，默认为继续挑战。 "),
                    _c("br"),
                    _vm._v(
                      " 5. 当挑战计时倒数至0，挑战结束，无法领取连胜奖励。"
                    ),
                    _c("br"),
                    _vm._v(
                      " 6. 门票总价格低于或等于前一关，胜利不加连胜，失败挑战结束。"
                    ),
                    _c("br"),
                    _vm._v(" 7. 若对战平局，保留连胜次数，可继续挑战。 "),
                    _c("br"),
                    _vm._v("8. 连胜挑战活动可重复游玩，不限次数。 "),
                    _c("br"),
                    _vm._v(" 9. 连胜挑战活动如遇BUG，解释权，属于口令专员。"),
                    _c("br"),
                  ],
                  2
                ),
                _vm.battle_challenge_des_btn_show
                  ? _c(
                      "div",
                      { staticClass: "challenge_des_btn flex flex-center-1" },
                      [
                        _vm.battleChallengeDetail.winningSteakCount > 0
                          ? _c(
                              "button",
                              {
                                staticClass: "agree-btn",
                                on: { click: _vm.onGCRequestJoinChallenge },
                              },
                              [_vm._v("同意")]
                            )
                          : _c(
                              "button",
                              {
                                staticClass: "noOk-btn",
                                on: {
                                  click: function ($event) {
                                    _vm.battle_challenge_des_show = false
                                  },
                                },
                              },
                              [_vm._v("资格不符")]
                            ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "Drawer",
        {
          attrs: {
            "class-name": "app-drawer",
            placement: "bottom",
            height: "350",
          },
          model: {
            value: _vm.case_detail_modal.flag,
            callback: function ($$v) {
              _vm.$set(_vm.case_detail_modal, "flag", $$v)
            },
            expression: "case_detail_modal.flag",
          },
        },
        [
          _c("c-battleCaseDetail", {
            attrs: { caseInfo: _vm.case_detail_modal.caseInfo },
          }),
        ],
        1
      ),
      _c("c-RewardModal", { ref: "case_reward_ui" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skeleton-user-info" }, [
      _c("div", { staticClass: "skeleton-avatar" }),
      _c("div", { staticClass: "skeleton-name" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "skeleton-roll-box" }, [
      _c("div", { staticClass: "skeleton-flash-light" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "status-hexagon battle-player__hexagon wait" },
      [
        _c("div", { staticClass: "depth-1" }),
        _c("div", { staticClass: "depth-2" }),
        _c("div", { staticClass: "depth-3" }, [
          _c("div", { staticClass: "icon" }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "status-hexagon battle-player__hexagon ready" },
      [
        _c("div", { staticClass: "depth-1" }),
        _c("div", { staticClass: "depth-2" }),
        _c("div", { staticClass: "depth-3" }, [
          _c("div", { staticClass: "icon" }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }